<template>
  <div id="app">
    <header>
      <template v-if="this.$route.path.startsWith('/finale')">
        <router-link to="/" :class="{ active: this.$route.path == '/' }">Coding Class Odense</router-link>
        <router-link to="/finale" :class="{
          active: this.$route.path.endsWith('/finale')
        }">Finale 2024</router-link>
        <router-link to="/finale/finalister" :class="{
          active: this.$route.path.startsWith('/finale/finalister')
        }">Finalister</router-link>
        <router-link to="/finale/workshops" :class="{
          active: this.$route.path.startsWith('/finale/workshops')
        }">Workshops</router-link>
        <!--<router-link to="/finale/info" :class="{
          active: this.$route.path.startsWith('/finale/info')
        }">Praktisk Info</router-link>-->
      </template>
      <template v-else>
        <router-link to="/" :class="{ active: this.$route.path == '/' }">Coding Class Odense</router-link>
        <router-link to="/online-undervisning" :class="{
          active: this.$route.path.startsWith('/online-undervisning')
        }">Coding Class-forløb</router-link>
        <router-link to="/video-tutorials" :class="{ active: this.$route.path.startsWith('/video-tutorials') }">Video tutorials</router-link>
        <router-link to="/tips-og-tricks" :class="{ active: this.$route.path.startsWith('/tips-og-tricks') }">Scratch
          tips</router-link>
        <!--<router-link to="/hotline">Kontakt</router-link>-->
        <!--<router-link
          to="/til-underviseren"
          :class="{ active: this.$route.path.startsWith('/til-underviseren') }"
          >Til læreren</router-link
        >-->
        
      </template>
    </header>
    <main>
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Varela+Round&display=swap");

body {
  overflow-y: scroll;
}

html,
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Varela Round", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#logo {
  width: 150px;
}

/* Style the header with a grey background and some padding */
header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 20px 10px;
}

@media (min-width: 768px) {
  header {
    flex-direction: row;
  }
}

/* Style the header links */
header a {
  color: black;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 4px;
}

/* Style the logo link (notice that we set the same value of line-height and font-size to prevent the header to increase when the font gets bigger */
header a.logo {
  font-size: 25px;
  font-weight: bold;
}

/* Change the background color on mouse-over */
header a:hover {
  background-color: #ddd;
  color: black;
}

/* Style the active/current link*/
header a.active {
  font-weight: 600;
  text-decoration: underline;
}

main {
  max-width: 1000px;
  margin: 0 auto;
}

/* Generic content styling */
.content {}

.content--aligned {
  text-align: left;
}

.content--centered {
  text-align: center;
}

/* Buttons */
.purp {
  margin: 10px auto;
  background: #5000ff;
  color: #ffffff;
  width: 300px;
  padding: 10px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 15px;
}

.bullet {
  display: inline-block;
  background: #00ffd4;
  color: #000000;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 50%;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue